export type AuthContext = 'register' | 'login' | 'generic';

function normalizeMessage(raw?: string): string {
  if (!raw) return '';
  try {
    return String(raw).trim();
  } catch {
    return '';
  }
}

export function translateAuthError(error: any, _context: AuthContext = 'generic'): string {
  try {
    const status: number | undefined = error?.response?.status;
    const data = error?.response?.data || {};
    const raw = normalizeMessage(data.error || data.message || error?.message);
    const msg = raw.toLowerCase();

    if (!error?.response) {
      if (error?.code === 'ECONNABORTED') {
        return 'Vypršel časový limit požadavku. Zkuste to prosím znovu.';
      }
      return 'Nelze se připojit k serveru. Zkontrolujte připojení a zkuste to znovu.';
    }

    if (status === 429) return 'Příliš mnoho pokusů. Zkuste to prosím za chvíli.';
    if (status && status >= 500) return 'Chyba serveru. Zkuste to prosím později.';

    if (/first_name/.test(msg) && /last_name/.test(msg)) {
      return 'Zadejte prosím jméno i příjmení.';
    }
    if (msg.includes('invalid email address')) {
      return 'Zadejte platný e‑mail.';
    }
    if (/email already (registered|in use)/.test(msg)) {
      return 'Tento e‑mail je již registrován. Přihlaste se nebo použijte jiný e‑mail.';
    }
    if (msg.includes('invalid credentials')) {
      return 'Nesprávný e‑mail nebo heslo.';
    }
    if (msg.includes('email is required')) {
      return 'Zadejte e‑mail.';
    }
    if (/password/.test(msg) && (/min/.test(msg) || /at least/.test(msg) || /min=8/.test(msg))) {
      return 'Heslo musí mít alespoň 8 znaků.';
    }
    if (/failed to (hash password|create user|generate token)/.test(msg) || /database error/.test(msg)) {
      return 'Na naší straně došlo k chybě. Zkuste to prosím znovu.';
    }

    if (status === 400) return 'Zkontrolujte vyplněná pole.';
    if (status === 401) return 'Nesprávné údaje. Zkuste to znovu.';
    if (status === 403) return 'Přístup byl odepřen.';

    if (raw) {
      return raw;
    }
    return 'Něco se nepovedlo. Zkuste to prosím znovu.';
  } catch {
    return 'Něco se nepovedlo. Zkuste to prosím znovu.';
  }
}
